(function () {
  function initSliders() {
    document.querySelectorAll('.related-products').forEach(container => {
      if (container.dataset.sliderInit) return;

      const slider = container.querySelector('.related_slider');
      const nextBtn = container.querySelector('.button-next');
      const prevBtn = container.querySelector('.button-prev');
      const pagination = container.querySelector('.swiper-pagination');

      if (!slider || !nextBtn || !prevBtn || !pagination) return;

      container.dataset.sliderInit = 'true';

      new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          320: { slidesPerView: 2, spaceBetween: 20 },
          750: { slidesPerView: 3, spaceBetween: 30 },
          990: { slidesPerView: 4, spaceBetween: 40 }
        }
      });
    });
  }

  const interval = setInterval(() => {
    initSliders();
    const allDone = [...document.querySelectorAll('.related-products')]
      .every(c => c.dataset.sliderInit);
    if (allDone && document.querySelector('.related-products')) {
      clearInterval(interval);
    }
  }, 300);
})();